import React from 'react';
import { Helmet } from 'react-helmet';
import { useTranslation } from 'react-i18next';

import Alert from 'reactstrap/lib/Alert';

import { receiveTickets } from '@ttstr/actions';
import { Container, LoadingSpinner, useIntl, Masonry, ContentrArea } from '@ttstr/components';
import { AppState } from '@ttstr/reducers';
import { useActions, useShallowEqualSelector } from '@ttstr/utils';

const TicketListing: React.FC = () => {
  const { t } = useTranslation();
  const { loading, tickets } = useShallowEqualSelector(mapStateToProps);
  const { receiveTickets } = useActions(mapDispatchToProps);
  const { language } = useIntl();

  React.useEffect(() => {
    receiveTickets();
  }, [language]);

  return (
    <div>
      <Container fluid className="header-image header-tickets" />

      <article className="pb-5 ticket-listing mb-5">
        <Container className="list-page mt-0">
          <Helmet>
            <title>{t(`TICKETLISTING.TITLE`)}</title>
            <body className="ticket-listing-page" />
          </Helmet>

          <ContentrArea id="above-listing" />

          <h1 className="text-center mb-5">{t(`Traumfabrik Tour 2026`)}</h1>

          {loading ? ( // if loading
            <LoadingSpinner label={t(`LOADING.TICKETS`)} />
          ) : tickets.length === 0 ? ( // if no tickets
            <Alert color="info">{t(`MASONRY.NO_ITEMS`)}</Alert>
          ) : (
            // else show tickets
            <Masonry
              id="ticket-listing"
              products={tickets.filter((t) => t.tag_ids.includes(9359))}
              type="list"
              // filters={['soldOut']}
              showCity
              showLocation
              showSubtitle
              showTags
            />
          )}

          <h1 className="text-center my-5">{t(`Andere Events`)}</h1>

          {loading ? ( // if loading
            <LoadingSpinner label={t(`LOADING.TICKETS`)} />
          ) : tickets.length === 0 ? ( // if no tickets
            <Alert color="info">{t(`MASONRY.NO_ITEMS`)}</Alert>
          ) : (
            // else show tickets
            <Masonry
              id="ticket-listing"
              products={tickets.filter((t) => !t.tag_ids.includes(9359))}
              type="list"
              // filters={['soldOut']}
              showCity
              showLocation
              showSubtitle
              showTags
            />
          )}

          <ContentrArea id="below-listing" />
        </Container>
      </article>
    </div>
  );
};

const mapStateToProps = (state: AppState) => {
  const { tickets, loading } = state.Tickets;
  return {
    tickets,
    loading,
  };
};

const mapDispatchToProps = {
  receiveTickets,
};

export default React.memo(TicketListing);
